import BaseService from "../../BaseService";
import LoginResponse from "./LoginResponse";
import RegisterResponse from "./RegisterResponse";
import { AxiosResponse } from "axios";

import { RegisterFormInputs } from "../../../components/RegisterFormPremium/RegisterFormPremium";

export default class AuthService extends BaseService {

    login(email: string, password: string): Promise<AxiosResponse<LoginResponse>> {
        return this.axios.post(`/auth/login`, {
            email,
            password,
        });
    }

    create(user: RegisterFormInputs): Promise<AxiosResponse<RegisterResponse>> {
        return this.axios.post(`/auth/register`, {
            ...user,
        });
    }

    me(): Promise<AxiosResponse<LoginResponse>> {
        return this.axios.post(`/auth/me`);
    }

    forgotPassword(email: string): Promise<AxiosResponse<any>> {
        return this.axios.post(`/auth/forgot-password`, { email });
    }

    resetPassword(token: string, email: string, password: string, password_confirmation: string): Promise<AxiosResponse<any>> {
        return this.axios.post(`/auth/reset-password`, { token, email, password, password_confirmation });
    }

}
